import { Component, ChangeDetectorRef, Inject } from '@angular/core';
import { NbResetPasswordComponent, NbAuthService, NB_AUTH_OPTIONS } from '@nebular/auth';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from '../../../@core/backend/common/services/users.service';

@Component({
    selector: 'ngx-reset-pass',
    templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent extends NbResetPasswordComponent {

    constructor(
        protected service: NbAuthService,
        protected userService: UsersService,
        cd: ChangeDetectorRef,
        router: Router,
        @Inject(NB_AUTH_OPTIONS) protected options = {},
        private route: ActivatedRoute
    ) {
        super(service, options, cd, router);
    }
    ngOnInit(): void {
        let email = this.route.snapshot.queryParamMap.get('Email');
        if (email) {
            this.user.Email = email;
        }
    }
    resetPass(): void {

        let email = this.route.snapshot.queryParamMap.get('Email');
        if (email) {
            this.user.Email = email;
        }

        super.resetPass();
    }
}